import "./WorkflowDataCard.css";

import {
  ProjectTypeBiocharIcon,
  ProjectTypeBiodiversityIcon,
  ProjectTypeBioEnergyIcon,
  ProjectTypeConstructedWetlandIcon,
  ProjectTypeEnhancedWeatheringIcon,
  ProjectTypeForestryAndWoodlandCreationIcon,
  ProjectTypeHedgerowAndAgroforestryIcon,
  ProjectTypeLivestockFeedIcon,
  ProjectTypeNutrientNeutralityIcon,
  ProjectTypePeatlandIcon,
  ProjectTypeRewildingIcon,
  ProjectTypeSaltmarshRestorationIcon,
  ProjectTypeSeagrassRestorationIcon,
  ProjectTypeSoilCarbonIcon,
  WorkflowBlueIcon,
} from "../../../../../../../assets";
import { Button, InformationBox } from "../../../../../../../widget";
import { WorkflowDataCardModel } from "../models";

interface WorkflowDataCardProps {
  data: WorkflowDataCardModel;
  isActive: boolean;
  isProject: boolean;
}

const getIconFromProjectType = (projectTypeUuid: string): JSX.Element => {
  switch (projectTypeUuid) {
    case "f841838b-8ea4-4854-a26d-aeeb6b5284c7":
      return <ProjectTypeForestryAndWoodlandCreationIcon />;
    case "81fe62ab-32f1-4019-9e74-40f76d8a1fb5":
      return <ProjectTypeHedgerowAndAgroforestryIcon />;
    case "fcd54321-6ff6-48fa-b42d-fd485205fea3":
      return <ProjectTypeRewildingIcon />;
    case "7a173441-af80-4b2d-8043-f995c6ec8059":
      return <ProjectTypePeatlandIcon />;
    case "f4b67ac1-dcec-4e81-adab-a6fa6a96079f":
      return <ProjectTypeSoilCarbonIcon />;
    case "b2962df1-f83b-4e99-885d-6eb008211b5f":
      return <ProjectTypeBioEnergyIcon />;
    case "3d78fa92-0769-4400-8138-3f2a5bf37264":
      return <ProjectTypeSeagrassRestorationIcon />;
    case "c7686b9b-3209-445a-88ce-03845168b577":
      return <ProjectTypeConstructedWetlandIcon />;
    case "ee020ebb-f1f0-49d6-84d6-84c0e305aadf":
      return <ProjectTypeSaltmarshRestorationIcon />;
    case "77a61b62-429e-486a-8508-a023a876c90c":
      return <ProjectTypeEnhancedWeatheringIcon />;
    case "385b5d60-f97a-4652-b63e-cc6af292d1f2":
      return <ProjectTypeBiocharIcon />;
    case "5ddd0af4-1c0b-410c-9df4-e6f76ad37cfa":
      return <ProjectTypeLivestockFeedIcon />;
    case "9009eefc-fe4d-4c13-8bad-b99123f4b0aa":
      return <ProjectTypeBiodiversityIcon />;
    case "56c274e9-2f78-477c-b6da-bc92d07fb2de":
      return <ProjectTypeNutrientNeutralityIcon />;
    default:
      return <WorkflowBlueIcon />;
  }
};
export const WorkflowDataCard = ({ data, isActive, isProject }: WorkflowDataCardProps): JSX.Element => {
  return (
    <div className={`WorkflowDataCardContainer ${isActive ? "Active" : undefined}`}>
      <div className="WorkflowDataCardHeader">
        <div className="WorkflowDataCardIcon">{getIconFromProjectType(data.projectTypeUuid)}</div>
        <div className="WorkflowDataCardTaskCount">
          <p className="body2Light">{data.tasks}</p>
          <p className="body3Light">Tasks</p>
        </div>
      </div>
      <div className="WorkflowDataCardTitleAndOrganisation">
        <h3>{data.name}</h3>
        <p className="body2Light">by {data.organisationName ?? "Kana"}</p>
      </div>
      {data.isExpired && (
        <InformationBox size="small" variant="info">
          <p className="body2Light">This template has been expired</p>
        </InformationBox>
      )}
      <div className="WorkflowDataCardDescription">
        <p className="body2Light">{data.description}</p>
      </div>
      <div className="WorkflowDataCardButtons">
        {isActive ? (
          <p className="body3">{isProject ? "Showing projects" : "Showing deals"}</p>
        ) : (
          <Button
            text={isProject ? "Show projects" : "Show deals"}
            onClick={data.onShowProjectsClick}
            textUnderline
            variant="reversedPrimary"
            size="extraSmall"
            textBold
            hasNoPadding
          />
        )}
        <div className="WorkflowDataCardButtonDivider" />
        <Button
          text="View workflow"
          onClick={data.onViewWorkflowClick}
          textUnderline
          variant="reversedPrimary"
          size="extraSmall"
          textBold
          hasNoPadding
        />
      </div>
    </div>
  );
};
